import React from "react";
import Helmet from "react-helmet";
import config from "../../data/SiteConfig";

import "typeface-karla";
import "./normalize.css";
import "./index.scss";

export default class MainLayout extends React.Component {
  getLocalTitle() {
    function capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
    const pathPrefix = config.pathPrefix ? config.pathPrefix : "/";
    const currentPath = this.props.location.pathname
      .replace(pathPrefix, "")
      .replace("/", "");
    let title = "";
    if (currentPath === "") {
      title = "Home";
    } else if (currentPath === "tags/") {
      title = "Tags";
    } else if (currentPath === "categories/") {
      title = "Kategorien";
    } else if (currentPath === "about/") {
      title = "Über mich";
    } else if (currentPath.indexOf("posts")) {
      title = "Meine Blog-Artikel";
    } else if (currentPath.indexOf("tags/")) {
      const tag = currentPath
        .replace("tags/", "")
        .replace("/", "")
        .replace("-", " ");
      title = `Tagged in ${capitalize(tag)}`;
    } else if (currentPath.indexOf("categories/")) {
      const category = currentPath
        .replace("categories/", "")
        .replace("/", "")
        .replace("-", " ");
      title = `${capitalize(category)}`;
    }
    return title;
  }

  GetIEVersion() {
    var sAgent = window.navigator.userAgent;
    var Idx = sAgent.indexOf("MSIE");

    // If IE, return version number.
    if (Idx > 0)
      return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf(".", Idx)));
    else if (!!navigator.userAgent.match(/Trident\/7\./))
      // If IE 11 then look for Updated user agent string.
      return 11;
    else return 0; //It is not IE
  }

  isIE() {
    this.GetIEVersion() > 0 ? true : false;
  }

  componentDidMount() {
    this.isIE() && document.body.classList.add("isIE");
  }

  componentWillUnmount() {
    this.isIE() && document.body.classList.remove("isIE");
  }

  render() {
    const { children } = this.props;
    return (
      <div>
        <Helmet>
          <title>{`${config.siteTitle} |  ${this.getLocalTitle()}`}</title>
          <meta name="description" content={config.siteDescription} />
        </Helmet>

        {children()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/index.jsx